import { useAppSelector } from "integrations/redux/hooks"
import { UserLocationShareContainer } from "./UserLocationShareContainer"
import { selectOpenUserLocationShareIds } from "plugins/UserLocationShare/state/selectors"

export const UserLocationShareProvider = () => {
    const openLocationShareIds = useAppSelector(selectOpenUserLocationShareIds)
    return (
        <div className="flex flex-col">
            {openLocationShareIds.toSorted().map((id) => (
                <div
                    key={id}
                    style={{
                        zIndex: openLocationShareIds.findIndex((shareId) => shareId === id),
                    }}
                >
                    <UserLocationShareContainer id={id} />
                </div>
            ))}
        </div>
    )
}
